export const SmartLoaderConfig = {
    excludedRoutes: [
        // '/solar/classes.*'
        '/support/knowledge-base',
        '/support'
    ],
    excludedApis: [
        // '/api/order/sales/cc/payment',
        '/api/version',
        '/api/alert/show',
        '/api/file/store-details',
        '/api/file/complete',

        // Agora
        'api/agora/keywords/dictionary',
        'api/hamlet/tag/dictionary',
        '/api/agora/employee/broadcast',

        'api/notifications/list/user',
        'api/agora/account/check/email',
        '/api/agora/employee/email',

        // Sahara
        '/api/location/vat/validate',

        '/users/guidance',
        '/profile',

        // Seller Products
        '/product-seller/pre-product/pricing/compute',
        '/api/agora/list/account-accreditation-type'
    ]
};



// WEBPACK FOOTER //
// ./src/app/core/config/smart-loader.config.ts